import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux'
import './assets/styles/index.css';
import App from './components/App'
import configureStore from './store';
import createHistory from 'history/createBrowserHistory';

const store = configureStore(window.__REDUX_STATE__ || {});
const history = createHistory();
history.listen((action) => {
    if (history.action === 'PUSH') {
      window.scrollTo(0,0)
    }
});

const AppBundle = (
  <Provider store={store}>
    <Router history={history}>
      <App/>
    </Router>
  </Provider>
);

ReactDOM.hydrate(AppBundle, document.getElementById('root'));

export default store;



// WEBPACK FOOTER //
// ./src/index.js